import { useQuery } from '@tanstack/react-query';
import { listFlags } from 'sync/flags-service/flags-service';
import { Flags } from 'utils/flags';
import { ReactQueryKeys } from 'utils/react-query';

export function useFlagsList({ organizationId, enabled }: { organizationId: string; enabled: boolean }) {
  const accessPostLoginListKey = ReactQueryKeys.LOGIN_FLAGS_LIST(organizationId);

  const queryList = useQuery(accessPostLoginListKey, () => listFlags(organizationId), {
    enabled,
    cacheTime: 0,
    staleTime: 0,
    retry: false,
  });

  const preLoginFlagsList = queryList.data ?? ({} as Flags);
  const postLoginFlagsList = queryList.data ?? ({} as Flags);

  const triggerPreLoginFlagsList = async () => {
    return queryList.refetch();
  };

  const triggerPostLoginFlagsList = async (orgId: string) => {
    return queryList.refetch({ queryKey: [ReactQueryKeys.LOGIN_FLAGS_LIST(orgId), orgId] });
  };

  return {
    query: queryList,
    preLoginFlagsList,
    isLoading: queryList.isLoading,
    isSuccess: queryList.isSuccess,
    error: queryList.error,
    queryList,
    postLoginFlagsList,
    isLoadingList: queryList.isLoading,
    isSuccessList: queryList.isSuccess,
    listError: queryList.error,
    triggerPreLoginFlagsList,
    triggerPostLoginFlagsList,
  };
}
